import { tiendasApi } from '../api'

export const workshopsApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getPaginatedWorkshops: builder.mutation({
            query: ({ searchText, page, limit, orderBy, orderAs }) => ({
                url: `workshops?searchText=${searchText}&page=${page}&limit=${limit}&orderBy=${orderBy}&orderAs=${orderAs}`,
                method: 'GET',
            })
        }),
        getByIdWorkshops: builder.mutation({
            query: ({ id }) => ({
                url: `workshops/${id}`,
                method: 'GET',
            })
        }),
        createWorkshops: builder.mutation({
            query: (formData) => ({
                url: `workshops`,
                method: 'POST',
                body: formData,
                prepareHeaders: (headers) => {
                    if (formData instanceof FormData) {
                        headers.delete('Content-Type');
                    }
                    return headers;
                }
            })
        }),
        updateWorkshops: builder.mutation({
            query: ({ id, formData }) => ({
                url: `workshops/${id}`,
                method: 'PUT', 
                body: formData,
                prepareHeaders: (headers) => {
                    if (formData instanceof FormData) {
                        headers.delete('Content-Type');
                    }
                    return headers;
                },
            }),
        }),
        removeWorkshops: builder.mutation({
            query: ({ id }) => ({
                url: `workshops/${id}`,
                method: 'DELETE',
            })
        }),
    })
})

export const {
    useGetPaginatedWorkshopsMutation,
    useGetByIdWorkshopsMutation,
    useCreateWorkshopsMutation,
    useUpdateWorkshopsMutation,
    useRemoveWorkshopsMutation,
} = workshopsApiSlice